import styled from 'styled-components';

export const DigitalGloveBoxCardWrapper = styled.div`
  max-width: 912px;
  background: #ffffff;
  border: 1px solid #d9dde9;
  box-sizing: border-box;
  box-shadow: 0px 2px 3px rgba(24, 53, 88, 0.1);
  border-radius: 8px;
  margin: 0 auto;
  overflow: hidden;

  & [data-testid='card-body'] {
    padding-bottom: 0;
  }
`;
